import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router";
import { GET_EXTENDED_CARD } from "../../redux/reducers/cardReducer";
import InfoIcon from "@mui/icons-material/Info";

interface ICard {
  cardId: string;
  cardSystemId: string;
  startDate: Date;
  endDate: Date;
}

export function CardHistory() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const historyCards = useSelector<any, ICard[]>(
    (state: any) => state.card.cardWithHistory.history
  );

  const carePrincipalId = useSelector<any, ICard[]>(
    (state: any) => state.session.selectedCarePrincipal.id
  );

  const handleInspectExpiredCard = (cardSystemId: string) => {
    const params = {
      cardSystemId: cardSystemId,
      carePrincipalId: carePrincipalId,
    };
    dispatch({ type: GET_EXTENDED_CARD, params });
  };

  return (
    <>
      {historyCards.length !== 0 ? (
        <Box className="CardHistory">
          <Stack spacing={1}>
            <Container
              disableGutters
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 2,
              }}
            >             
            <InfoIcon sx={{ width: "4vh", height: "4vh", color: "#3399FF" }} />
              <Typography variant="h4" component="div">
                {t("searchCard.history.title")}
              </Typography>
            </Container>
            {historyCards.map((card) => (
              <Box key={card.cardId}>
                <Button
                  sx={{ marginTop: "1rem" }}
                  component={NavLink}
                  to={"/search-card/history/" + card.cardSystemId}
                  variant="contained"
                  onClick={() => handleInspectExpiredCard(card.cardSystemId)}
                >
                  <Typography>
                    {card.startDate.toLocaleDateString("sv")}
                  </Typography>
                  <Typography sx={{ mx: 1 }}>-</Typography>
                  <Typography>
                    {card.endDate.toLocaleDateString("sv")}
                  </Typography>
                </Button>
              </Box>
            ))}
          </Stack>
        </Box>
      ) : null}
    </>
  );
}
